const TradingSessionEventType = Object.freeze({
    ABANDON_ORDER: 'ABANDON_ORDER',
    ABANDON_PAYMENTS: 'ABANDON_PAYMENTS',
    ADMIN_NOTE: 'ADMIN_NOTE', // Backoffice only
    ADMIN_X_READ: 'ADMIN_X_READ', // Backoffice only
    CASH_DRAWER: 'CASH_DRAWER',
    CASH_FLOAT: 'CASH_FLOAT',
    CASH_IN: 'CASH_IN',
    CASH_OUT: 'CASH_OUT',
    CASHBACK: 'CASHBACK',
    DEVICE_OFFLINE: 'DEVICE_OFFLINE',
    DEVICE_ONLINE: 'DEVICE_ONLINE',
    DEVICE_RESUME: 'DEVICE_RESUME',
    ERROR_API: 'ERROR_API',
    GRATUITY: 'GRATUITY',
    SESSION_BANK: 'SESSION_BANK',
    SESSION_CASH: 'SESSION_CASH',
    SESSION_CLOSE: 'SESSION_CLOSE',
    SESSION_OPEN: 'SESSION_OPEN',
    TICKETS_PRINTED: 'TICKETS_PRINTED',
    USER_LOGIN: 'USER_LOGIN',
    USER_LOGOUT: 'USER_LOGOUT',
    USER_SWITCH: 'USER_SWITCH',
    VOUCHER: 'VOUCHER',
    X_READ_GENERATED: 'X_READ_GENERATED', // Recorded automatically in the API
    X_READ_PRINTED: 'X_READ_PRINTED',
    Z_READ_GENERATED: 'Z_READ_GENERATED', // Recorded automatically in the API
    Z_READ_PRINTED: 'Z_READ_PRINTED',
    Z_READ_VIEWED: 'Z_READ_VIEWED', // Recorded automatically in the API
});

module.exports = TradingSessionEventType;
